import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../../Constants";
import LeavePlan from "../..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  iscarryforwardallowed: false,
  iscarryforwardpolicy: null,
  forwardtypeid: null,
  carryForwardType: [
    {
      displayname: "Fixed Number",
      displayvalue: 2,
    },
    {
      displayname: "Percentage",
      displayvalue: 3,
    },
  ],
  Selectedforwardtypeid: {
    displayname: "Fixed Number",
    displayvalue: 2,
  },
  Selectedencashmenttypeid: {
    displayname: "Fixed Number",
    displayvalue: 2,
  },
  carryforwardunusedperc: 0,
  carryforwardunused: 0,
  pendingactiontypeid: null,
  remaningperc: null,
  noofremaning: null,
  remaningType: [
    {
      displayname: "All",
      displayvalue: 1,
    },
    {
      displayname: "Fixed Number",
      displayvalue: 2,
    },
    {
      displayname: "Percentage",
      displayvalue: 3,
    },
  ],
  remaningtypeid: { displayvalue: null, displayname: null },
  transferleaveid: { displayvalue: null, displayname: null },
  LeaveList: [],
  encashmentunused: null,
  encashmentunusedperc: null,
  encashmenttypeid: {
    displayname: null,
    displayvalue: null,
  },
  initiateEncashment: false,
  initiateEncashmentleavecount: 0,
};
class CarryForwardEncashment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentDidMount() {
    this.getLeaveList();
  }

  getLeaveList() {
    const { details } = this.props.InitLeavesPolicy;
    const leavepolicyid = this.props.InitLeavesPolicy.leavepolicyid
      ? this.props.InitLeavesPolicy.leavepolicyid
      : null;
    let leavetypeids = [];
    if (details.length > 0) {
      for (const detail of details) {
        leavetypeids.push(detail.leavetypeid);
      }
    } else {
      leavetypeids = null;
    }

    instance
      .post(`/leaves/leavelistbypolicyid`, {
        leavepolicyid,
        leavetypeids,
      })
      .then(
        (result) => {
          this.setState(
            {
              LeaveList: result.data.result,
            },
            () => {
              this.SetValues(this.props);
            },
          );
        },
        (error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        },
      );
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.getLeaveList();
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const policyPlan = props.InitLeavesPolicy.policy[ParentIndex];
      const { iscarryforwardallowed } = policyPlan;
      let carryObject = {};
      if (iscarryforwardallowed) {
        let transferleaveid = null;
        let pendingactiontypeid = null;
        let remaningtypeid;
        let Selectedforwardtypeid;
        let forwardtypeid;
        const { iscarryforwardpolicy } = policyPlan.carryforward;
        if (iscarryforwardpolicy) {
          forwardtypeid = policyPlan.carryforward.carryforwardpolicy.forwardtypeid;
          pendingactiontypeid = policyPlan.carryforward.carryforwardpolicy.pendingactiontypeid;
          if (forwardtypeid != 1) {
            Selectedforwardtypeid = this.state.carryForwardType.find(
              (x) => x.displayvalue == forwardtypeid,
            );
          }
          if (pendingactiontypeid != 1) {
            remaningtypeid = this.state.remaningType.find(
              (x) =>
                x.displayvalue
                == policyPlan.carryforward.carryforwardpolicy.remaningtypeid,
            );
          }
          if (policyPlan.carryforward.carryforwardpolicy.transferleaveid) {
            transferleaveid = this.state.LeaveList.find(
              (x) =>
                x.displayvalue
                == policyPlan.carryforward.carryforwardpolicy.transferleaveid,
            );
          }
          carryObject = {
            iscarryforwardpolicy,
            forwardtypeid:
              policyPlan.carryforward.carryforwardpolicy.forwardtypeid || null,
            Selectedforwardtypeid:
              Selectedforwardtypeid || this.state.Selectedforwardtypeid,
            carryforwardunusedperc:
              policyPlan.carryforward.carryforwardpolicy.carryforwardunusedperc,
            carryforwardunused:
              policyPlan.carryforward.carryforwardpolicy.carryforwardunused,
            pendingactiontypeid:
              pendingactiontypeid || this.state.pendingactiontypeid,
            remaningtypeid: remaningtypeid || this.state.remaningtypeid,
            remaningperc:
              policyPlan.carryforward.carryforwardpolicy.remaningperc,
            noofremaning:
              policyPlan.carryforward.carryforwardpolicy.noofremaning,
            transferleaveid: transferleaveid || this.state.transferleaveid,
          };
        } else {
          const { encashmenttypeid } = policyPlan.carryforward.encashmentpolicy;
          pendingactiontypeid = policyPlan.carryforward.encashmentpolicy.pendingactiontypeid;
          let Selectedencashmenttypeid;
          if (encashmenttypeid != 1) {
            Selectedencashmenttypeid = this.state.carryForwardType.find(
              (x) => x.displayvalue == encashmenttypeid,
            );
          }
          if (pendingactiontypeid != 1) {
            remaningtypeid = this.state.remaningType.find(
              (x) =>
                x.displayvalue
                == policyPlan.carryforward.encashmentpolicy.remaningtypeid,
            );
          }
          if (policyPlan.carryforward.encashmentpolicy.transferleaveid) {
            transferleaveid = this.state.LeaveList.find(
              (x) =>
                x.displayvalue
                == policyPlan.carryforward.encashmentpolicy.transferleaveid,
            );
          }
          carryObject = {
            iscarryforwardpolicy,
            encashmenttypeid:
              policyPlan.carryforward.encashmentpolicy.encashmenttypeid || null,
            Selectedencashmenttypeid:
              Selectedencashmenttypeid || this.state.Selectedencashmenttypeid,
            encashmentunusedperc:
              policyPlan.carryforward.encashmentpolicy.encashmentunusedperc,
            encashmentunused:
              policyPlan.carryforward.encashmentpolicy.encashmentunused,
            pendingactiontypeid:
              pendingactiontypeid || this.state.pendingactiontypeid,
            remaningtypeid: remaningtypeid || this.state.remaningtypeid,
            remaningperc: policyPlan.carryforward.encashmentpolicy.remaningperc,
            noofremaning: policyPlan.carryforward.encashmentpolicy.noofremaning,
            transferleaveid: transferleaveid || this.state.transferleaveid,
          };
        }
      } else if (!iscarryforwardallowed) {
        this.setState({ ...ParentState });
      }
      this.setState({
        leavetypeid: props.leavetypeid,
        ParentIndex,
        iscarryforwardallowed,
        initiateEncashmentleavecount: policyPlan.initiateEncashmentleavecount,
        initiateEncashment: policyPlan.initiateEncashmentleavecount > 0,
        ...carryObject,
      });
    } else {
      this.setState({ ...ParentState })
    }
  }

  handleChange = (name, ...arg) => {
    switch (name) {
      case "iscarryforwardallowed": {
        this.setState({ [name]: arg[0] }, () => {
          if (!this.state.iscarryforwardallowed) {
            this.handleChange("iscarryforwardpolicy", null);
          } else this.UpdateReducer();
        });
        break;
      }
      case "iscarryforwardpolicy":
        this.setState({ [name]: arg[0] }, () => {
          switch (arg[0]) {
            case null:
              this.setState(
                () => ({
                  forwardtypeid: null,
                  encashmentunusedperc: 0,
                  encashmenttypeid: 1,
                  encashmentunused: 0,
                  transferleaveid: { displayvalue: null, displayname: null },
                  carryforwardunusedperc: 0,
                  carryforwardunused: 0,
                  remaningperc: 0,
                  noofremaning: 0,
                  remaningtypeid: { displayvalue: null, displayname: null },
                }),
                () => this.UpdateReducer(),
              );
              break;
            case true:
              this.setState(
                () => ({
                  iscarryforwardallowed: true,
                  forwardtypeid: 1,
                  transferleaveid: { displayvalue: null, displayname: null },
                  carryforwardunusedperc: 0,
                  carryforwardunused: 0,
                  remaningperc: 0,
                  noofremaning: 0,
                  remaningtypeid: { displayvalue: null, displayname: null },
                }),
                () => this.UpdateReducer(),
              );
              break;
            case false:
              this.setState(
                () => ({
                  iscarryforwardallowed: true,
                  forwardtypeid: null,
                  encashmentunusedperc: 0,
                  encashmentunused: 0,
                  encashmenttypeid: 1,
                  transferleaveid: { displayvalue: null, displayname: null },
                  carryforwardunusedperc: 0,
                  carryforwardunused: 0,
                  remaningperc: 0,
                  noofremaning: 0,
                  remaningtypeid: { displayvalue: null, displayname: null },
                }),
                () => this.UpdateReducer(),
              );
              break;

            default:
              break;
          }
        });
        break;
      case "forwardtypeid":
        this.setState(
          {
            [name]: arg[0],
            carryforwardunusedperc: 0,
            carryforwardunused: 0,
            pendingactiontypeid: null,
            Selectedforwardtypeid: {
              displayname: "Fixed Number",
              displayvalue: 2,
            },
          },
          () => this.UpdateReducer(),
        );
        break;
      case "encashmenttypeid": {
        let Selectedencashmenttypeid = {
          displayname: "Fixed Number",
          displayvalue: 2,
        };
        if (arg[0] == 2) {
          Selectedencashmenttypeid = {
            displayname: "Fixed Number",
            displayvalue: 2,
          };
        }
        this.setState(
          {
            [name]: arg[0],
            carryforwardunusedperc: 0,
            carryforwardunused: 0,
            pendingactiontypeid: null,
            Selectedencashmenttypeid,
          },
          () => this.UpdateReducer(),
        );
        break;
      }
      case "transferleaveid":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "Selectedforwardtypeid":
        this.setState(
          {
            [name]: arg[0],
            carryforwardunused: null,
            carryforwardunusedperc: null,
          },
          () =>
            this.setState(
              { forwardtypeid: this.state.Selectedforwardtypeid.displayvalue },
              () => this.UpdateReducer(),
            ),
        );
        break;
      case "Selectedencashmenttypeid":
        this.setState(
          {
            [name]: arg[0],
            encashmentunused: null,
            encashmentunusedperc: null,
          },
          () =>
            this.setState(
              {
                encashmenttypeid: this.state.Selectedencashmenttypeid
                  .displayvalue,
              },
              () => this.UpdateReducer(),
            ),
        );
        break;
      case "pendingactiontypeid":
        this.setState(
          {
            [name]: arg[0],
            remaningperc: null,
            noofremaning: null,
          },
          () => {
            let remaningtypeid = { displayname: null, displayvalue: null };
            if (arg[0] != 1) {
              remaningtypeid = {
                displayname: "All",
                displayvalue: 1,
              };
            }
            this.setState(
              {
                remaningtypeid,
                transferleaveid: { displayname: null, displayvalue: null },
                // noofremaning: arg[0] != 1 ? 1 : null,
              },
              () => this.UpdateReducer(),
            );
          },
        );
        break;
      case "remaningtypeid":
        this.setState(
          { [name]: arg[0], remaningperc: 0, noofremaning: 1 },
          () => {
            this.UpdateReducer();
            if (this.state.remaningtypeid.displayvalue == 1) {
              this.setState(
                {
                  remaningperc: null,
                  noofremaning: null,
                },
                () => this.UpdateReducer(),
              );
            } else if (this.state.remaningtypeid.displayvalue == 2) {
              this.setState(
                {
                  remaningperc: null,
                  noofremaning: 1,
                },
                () => this.UpdateReducer(),
              );
            } else if (this.state.remaningtypeid.displayvalue == 3) {
              this.setState(
                {
                  remaningperc: 1,
                  noofremaning: null,
                },
                () => this.UpdateReducer(),
              );
            }
            //  else {
            //     this.setState({ remaningperc: 0, noofremaning: 0 }, () => this.UpdateReducer())
            // }
          },
        );
        break;
      case "initiateEncashment":
        this.setState(
          { [name]: arg[0], initiateEncashmentleavecount: 0 },
          () => {
            if (this.state.initiateEncashment) {
              this.setState({ initiateEncashmentleavecount: 1 });
            }
            this.UpdateReducer();
          },
        );
        break;
      default:
        break;
    }
  };

  CommonNumberChange(name, max, event) {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (Number(event.target.value) > Number(max)) value = this.state[name];
      else value = event.target.value;
      value > 9 && (value = `0${value}`);
      if (name == "carryforwardunusedperc") {
        this.setState({ [name]: value, carryforwardunused: 0 }, () => {
          this.UpdateReducer();
        });
      } else if (name == "carryforwardunused") {
        this.setState({ [name]: value, carryforwardunusedperc: 0 }, () => {
          this.UpdateReducer();
        });
      }
      if (name == "encashmentunusedperc") {
        this.setState({ [name]: value, encashmentunused: 0 }, () => {
          this.UpdateReducer();
        });
      } else if (name == "encashmentunused") {
        this.setState({ [name]: value, encashmentunusedperc: 0 }, () => {
          this.UpdateReducer();
        });
      } else {
        this.setState({ [name]: value }, () => this.UpdateReducer());
      }
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    let { forwardtypeid } = this.state;
    if (forwardtypeid != 1) {
      forwardtypeid = this.state.Selectedforwardtypeid.displayvalue;
    }
    let { encashmenttypeid } = this.state;
    if (encashmenttypeid != 1) {
      encashmenttypeid = this.state.Selectedencashmenttypeid.displayvalue;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      iscarryforwardallowed: this.state.iscarryforwardallowed,
      initiateEncashmentleavecount: this.state.initiateEncashmentleavecount,
    };
    InitLeavesPolicy.policy[ParentIndex].carryforward = {
      iscarryforwardpolicy: this.state.iscarryforwardpolicy,
      carryforwardpolicy: {
        forwardtypeid: this.state.iscarryforwardpolicy ? forwardtypeid : null,
        carryforwardunusedperc:
          forwardtypeid != 1 ? this.state.carryforwardunusedperc : 0,
        carryforwardunused:
          forwardtypeid != 1 ? this.state.carryforwardunused : 0,
        pendingactiontypeid: this.state.iscarryforwardpolicy
          ? this.state.pendingactiontypeid
          : null,
        remaningtypeid: this.state.iscarryforwardpolicy
          ? this.state.remaningtypeid.displayvalue
          : null,
        remaningperc:
          this.state.iscarryforwardpolicy
            && this.state.remaningtypeid.displayvalue != 1
            ? this.state.remaningperc
            : 0,
        noofremaning:
          this.state.iscarryforwardpolicy
            && this.state.remaningtypeid.displayvalue != 1
            ? this.state.noofremaning
            : 0,
        transferleaveid: this.state.iscarryforwardpolicy
          ? this.state.transferleaveid.displayvalue
          : null,
      },
      encashmentpolicy: {
        encashmenttypeid: !this.state.iscarryforwardpolicy
          ? encashmenttypeid
          : null,
        encashmentunusedperc:
          !this.state.iscarryforwardpolicy && encashmenttypeid != 1
            ? this.state.encashmentunusedperc
            : 0,
        encashmentunused:
          !this.state.iscarryforwardpolicy && encashmenttypeid != 1
            ? this.state.encashmentunused
            : 0,
        pendingactiontypeid: !this.state.iscarryforwardpolicy
          ? this.state.pendingactiontypeid
          : null,
        remaningtypeid: !this.state.iscarryforwardpolicy
          ? this.state.remaningtypeid.displayvalue
          : null,
        remaningperc:
          !this.state.iscarryforwardpolicy
            && this.state.remaningtypeid.displayvalue != 1
            ? this.state.remaningperc
            : 0,
        noofremaning:
          !this.state.iscarryforwardpolicy
            && this.state.remaningtypeid.displayvalue != 1
            ? this.state.noofremaning
            : 0,
        transferleaveid: !this.state.iscarryforwardpolicy
          ? this.state.transferleaveid.displayvalue
          : null,
      },
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  validateNext() {
    this.props.click();
  }

  render() {
    const language = this.props.Language.carryforwardencash;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="inner-wrapper margin-top-20 opaque">
          <p className="form-main-header">
            <FormattedMessage
              id="LbCarryForwardEncashment"
              defaultMessage="Carry Forward & Encashment"
            />
          </p>
          <p className="depedent-select-list-head">
            <FormattedMessage
              id="LbWhatDoWeDo"
              defaultMessage="What do we do about unused leave balance, at the end of a leave cycle/year?"
            />
          </p>
          <div
            className="depedent-select-list"
            onClick={() => this.handleChange("iscarryforwardallowed", false)}
            aria-expanded={!this.state.iscarryforwardallowed}
          >
            <span>
              <FormattedMessage
                id="LbDontDoAnything"
                defaultMessage="Don't do anything, let the leave balance lapse"
              />
            </span>
            {!this.state.iscarryforwardallowed ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
                <span className="not-selected" />
              )}
          </div>
          <div
            className="depedent-select-list"
            onClick={() => this.handleChange("iscarryforwardpolicy", true)}
            aria-expanded={this.state.iscarryforwardpolicy == true}
          >
            <span>
              <FormattedMessage
                id="LbCarryForward"
                defaultMessage="Carry forward"
              />
            </span>
            {this.state.iscarryforwardpolicy == true ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
                <span className="not-selected " />
              )}
          </div>
          {/* Carry forward */}
          <div className="et-level2">
            <Collapse
              in={this.state.iscarryforwardpolicy}
              timeout={2}
              unmountOnExit
              className="padding30 overflow-initial"
            >
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("forwardtypeid", 1)}
                aria-expanded={this.state.forwardtypeid == 1}
              >
                <span>
                  <FormattedMessage
                    id="LbCarryForwardAllUnusedWithoutEncash"
                    defaultMessage="Carry forward all unused leaves to the next cycle, without any encashment"
                  />
                </span>
                {this.state.forwardtypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected " />
                  )}
              </div>
              <div
                className="depedent-select-list"
                aria-expanded={this.state.forwardtypeid != 1}
              >
                <p style={{ marginBottom: 4 }} className="t-14">
                  <FormattedMessage
                    id="LbCarryForwardOnly"
                    onClick={() => this.handleChange("forwardtypeid", 2)}
                    defaultMessage="Carry forward only"
                  />
                </p>

                <Select
                  className="form-control width58"
                  autofocus
                  placeholder="Select Type"
                  options={this.state.carryForwardType}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(
                    this,
                    "Selectedforwardtypeid",
                  )}
                  value={this.state.Selectedforwardtypeid}
                />

                <InputValues
                  min="1"
                  field={
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? "carryforwardunused"
                      : "carryforwardunusedperc"
                  }
                  max={
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? "300"
                      : "99"
                  }
                  onChange={this.CommonNumberChange.bind(
                    this,
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? "carryforwardunused"
                      : "carryforwardunusedperc",
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? "300"
                      : "99",
                  )}
                  value={
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? this.state.carryforwardunused
                      : this.state.carryforwardunusedperc
                  }
                  defaultvalue={
                    this.state.Selectedforwardtypeid.displayvalue == 2
                      ? this.state.carryforwardunused
                      : this.state.carryforwardunusedperc
                  }
                  disabled={this.state.forwardtypeid == 1}
                />

                <FormattedMessage
                  id="LbOfUnusedLeaves"
                  defaultMessage="of unused leaves"
                />
                <span onClick={() => this.handleChange("forwardtypeid", 2)}>
                  {this.state.forwardtypeid != 1 ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                      <span className="not-selected " />
                    )}
                </span>
              </div>
              <div className="et-level3">
                <Collapse
                  in={this.state.forwardtypeid != 1}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("pendingactiontypeid", 1)}
                    aria-expanded={this.state.pendingactiontypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="LbLapseTheRemaining"
                        defaultMessage="Lapse the remaining "
                      />
                    </span>
                    {this.state.pendingactiontypeid == 1 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected " />
                      )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("pendingactiontypeid", 2)}
                    aria-expanded={this.state.pendingactiontypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbEncashTheRemaining"
                        defaultMessage="Encash the remaining"
                      />
                    </span>
                    {this.state.pendingactiontypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected " />
                      )}
                  </div>
                  <div className="et-level4">
                    <Collapse
                      in={this.state.pendingactiontypeid == 2}
                      timeout={2}
                      unmountOnExit
                      className="padding20 overflow-initial"
                    >
                      <span className="margin-bottom-20 width200p">
                        <Select
                          class="form-control"
                          autofocus
                          placeholder="Select Type"
                          options={this.state.remaningType}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.handleChange.bind(
                            this,
                            "remaningtypeid",
                          )}
                          value={this.state.remaningtypeid}
                          isDisabled={this.state.pendingactiontypeid != 2}
                        />
                      </span>
                      <InputValues
                        min="1"
                        field={
                          this.state.remaningtypeid.displayvalue == 2
                            ? "noofremaning"
                            : "remaningperc"
                        }
                        max={
                          this.state.remaningtypeid.displayvalue == 2
                            ? "365"
                            : "99"
                        }
                        onChange={this.CommonNumberChange.bind(
                          this,
                          this.state.remaningtypeid.displayvalue == 2
                            ? "noofremaning"
                            : "remaningperc",
                          this.state.remaningtypeid.displayvalue == 2
                            ? "365"
                            : "99",
                        )}
                        value={
                          this.state.remaningtypeid.displayvalue == 2
                            ? this.state.noofremaning
                            : this.state.remaningperc
                        }
                        defaultvalue={
                          this.state.remaningtypeid.displayvalue == 2
                            ? this.state.noofremaning
                            : this.state.remaningperc
                        }
                        disabled={this.state.remaningtypeid.displayvalue == 1}
                      />

                      <p>
                        <ul className="padding0 margin-bottom-0">
                          <li style={{ listStyleType: "none" }}>
                            <p className="t-14 margin-bottom-0">
                              <FormattedMessage
                                id="LbFurtherRemainingLeaves"
                                defaultMessage="Further remaining leaves will be lapsed, if any"
                              />
                            </p>
                          </li>
                        </ul>
                      </p>
                    </Collapse>
                  </div>
                  {/* <div className="depedent-select-list" onClick={() => this.handleChange("pendingactiontypeid", 3)} aria-expanded={this.state.pendingactiontypeid == 3 ? true : false}>
                                        <span>
                                            <FormattedMessage id="LbTransferTheRemaining" defaultMessage="Transfer the remaining" />
                                        </span>
                                        {this.state.pendingactiontypeid == 3 ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected "></span>}
                                    </div> */}
                  {/* <div className="et-level4">
                                        <Collapse in={this.state.pendingactiontypeid == 3} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                            <span className="margin-bottom-20 width200p">
                                                <Select class="form-control" autofocus placeholder="Select Type"
                                                    options={this.state.remaningType}
                                                    getOptionLabel={(option) => option.displayname}
                                                    getOptionValue={(option) => option.displayvalue}
                                                    onChange={this.handleChange.bind(this, "remaningtypeid")}
                                                    value={this.state.remaningtypeid}
                                                />
                                            </span>
                                            <InputValues
                                                min="1"
                                                field={this.state.remaningtypeid.displayvalue == 2 ? "noofremaning" : "remaningperc"}
                                                max={this.state.remaningtypeid.displayvalue == 2 ? "365" : "100"}
                                                onChange={this.CommonNumberChange.bind(this,
                                                    this.state.remaningtypeid.displayvalue == 2 ? "noofremaning" : "remaningperc",
                                                    this.state.remaningtypeid.displayvalue == 2 ? "365" : "100"
                                                )}
                                                value={this.state.remaningtypeid.displayvalue == 2
                                                    ? this.state.noofremaning
                                                    : this.state.remaningperc}
                                                defaultvalue={this.state.remaningtypeid.displayvalue == 2
                                                    ? this.state.noofremaning
                                                    : this.state.remaningperc}
                                                disabled={this.state.remaningtypeid.displayvalue == 1}
                                            />

                                            <br />
                                            <FormattedMessage id="LbUnusedLeaveBalance" defaultMessage="unused leave balance to leave type" />
                                            <span className="margin-bottom-20 width200p margin-left-8">
                                                <Select class="form-control" autofocus placeholder="Select Type"
                                                    options={this.state.LeaveList}
                                                    getOptionLabel={(option) => option.displayname}
                                                    getOptionValue={(option) => option.displayvalue}
                                                    onChange={this.handleChange.bind(this, "transferleaveid")}
                                                    value={this.state.transferleaveid}
                                                />
                                            </span>
                                            <p>
                                                <ul className="padding0 margin-bottom-0">
                                                    <li style={{listStyleType:"none"}}>
                                                        <p className="t-14 margin-bottom-0">
                                                            <FormattedMessage id="LbFurtherRemainingLeaves" defaultMessage="Further remaining leaves will be lapsed, if any" />
                                                        </p>
                                                    </li>
                                                </ul>
                                            </p>
                                        </Collapse>
                                    </div> */}
                </Collapse>
              </div>
            </Collapse>
          </div>
          <div
            className="depedent-select-list"
            onClick={() => this.handleChange("iscarryforwardpolicy", false)}
            aria-expanded={this.state.iscarryforwardpolicy == false}
          >
            <span>
              <FormattedMessage id="LbEncash" defaultMessage="Encash" />
            </span>
            {this.state.iscarryforwardpolicy == false ? (
              <span className="floatright">
                <img src={CheckImg} height="20" />
              </span>
            ) : (
                <span className="not-selected " />
              )}
          </div>
          {/* Encash  */}
          <div className="et-level2">
            <Collapse
              in={this.state.iscarryforwardpolicy == false}
              timeout={2}
              unmountOnExit
              className="padding30 overflow-initial"
            >
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("encashmenttypeid", 1)}
                aria-expanded={this.state.encashmenttypeid == 1}
              >
                <span>
                  <FormattedMessage
                    id="LbEncashAllUnused"
                    defaultMessage="Encash all unused leaves, without any carry forward"
                  />
                </span>
                {this.state.encashmenttypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                    <span className="not-selected " />
                  )}
              </div>
              <div
                className="depedent-select-list"
                aria-expanded={
                  !!(
                    this.state.encashmenttypeid == 2
                    || this.state.encashmenttypeid == 3
                  )
                }
              >
                <FormattedMessage
                  id="LbEncashOnly"
                  defaultMessage="Encash only"
                />
                <span className="width200p margin-left-8">
                  <Select
                    className="form-control width58"
                    autofocus
                    placeholder="Select Type"
                    options={this.state.carryForwardType}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.handleChange.bind(
                      this,
                      "Selectedencashmenttypeid",
                    )}
                    value={this.state.Selectedencashmenttypeid}
                  />
                </span>
                <InputValues
                  min="1"
                  field={
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? "encashmentunused"
                      : "encashmentunusedperc"
                  }
                  max={
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? "365"
                      : "99"
                  }
                  onChange={this.CommonNumberChange.bind(
                    this,
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? "encashmentunused"
                      : "encashmentunusedperc",
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? "365"
                      : "99",
                  )}
                  value={
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? this.state.encashmentunused
                      : this.state.encashmentunusedperc
                  }
                  defaultvalue={
                    this.state.Selectedencashmenttypeid.displayvalue == 2
                      ? this.state.encashmentunused
                      : this.state.encashmentunusedperc
                  }
                  disabled={this.state.encashmenttypeid == 1}
                />
                {/* <span className='number-wrapper'>
                                    <input
                                        className="seatlimit"
                                        type="number"
                                        min="1"
                                        max={this.state.Selectedencashmenttypeid.displayvalue == 2 ? "300" : "100"}
                                        onChange={this.handleChange.bind(this, this.state.Selectedencashmenttypeid.displayvalue == 2 ? "encashmentunused" : "encashmentunusedperc")}
                                        value={this.state.Selectedencashmenttypeid.displayvalue == 2 ? this.state.encashmentunused : this.state.encashmentunusedperc}
                                        disabled={this.state.encashmenttypeid == 1}
                                    />
                                </span> */}
                <FormattedMessage
                  id="LbLeaves"
                  onClick={() => this.handleChange("encashmenttypeid", 2)}
                  defaultMessage="leaves"
                />
                {this.state.encashmenttypeid == 2
                  || this.state.encashmenttypeid == 3 ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span
                      className="not-selected "
                      onClick={() => this.handleChange("encashmenttypeid", 2)}
                    />
                  )}
              </div>
              <div className="et-level3">
                <Collapse
                  in={
                    this.state.encashmenttypeid == 2
                    || this.state.encashmenttypeid == 3
                  }
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("pendingactiontypeid", 1)}
                    aria-expanded={this.state.pendingactiontypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="LbLapseTheRemaining"
                        defaultMessage="Lapse the remaining"
                      />
                    </span>
                    {this.state.pendingactiontypeid == 1 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected " />
                      )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("pendingactiontypeid", 2)}
                    aria-expanded={this.state.pendingactiontypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbCarryForwardTheRemaining"
                        defaultMessage="Carry forward the remaining"
                      />
                    </span>
                    {this.state.pendingactiontypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                        <span className="not-selected " />
                      )}
                  </div>
                  <div className="et-level4">
                    <Collapse
                      in={this.state.pendingactiontypeid == 2}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <span className="margin-bottom-20 width200p">
                        <Select
                          class="form-control"
                          autofocus
                          placeholder="Select Type"
                          options={this.state.remaningType}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.handleChange.bind(
                            this,
                            "remaningtypeid",
                          )}
                          value={this.state.remaningtypeid}
                          isDisabled={this.state.pendingactiontypeid != 2}
                        />
                      </span>
                      <InputValues
                        min="1"
                        field={
                          this.state.remaningtypeid.displayvalue == 2
                            ? "noofremaning"
                            : "remaningperc"
                        }
                        max={
                          this.state.remaningtypeid.displayvalue == 2
                            ? "365"
                            : "100"
                        }
                        onChange={this.CommonNumberChange.bind(
                          this,
                          this.state.remaningtypeid.displayvalue == 2
                            ? "noofremaning"
                            : "remaningperc",
                          this.state.remaningtypeid.displayvalue == 2
                            ? "365"
                            : "100",
                        )}
                        value={
                          this.state.remaningtypeid.displayvalue == 2
                            ? this.state.noofremaning
                            : this.state.remaningperc
                        }
                        defaultvalue={
                          this.state.remaningtypeid.displayvalue == 2
                            ? this.state.noofremaning
                            : this.state.remaningperc
                        }
                        disabled={this.state.remaningtypeid.displayvalue == 1}
                      />

                      <p>
                        <ul className="padding0 margin-bottom-0">
                          <li style={{ listStyleType: "none" }}>
                            <p className="t-14 margin-bottom-0">
                              <FormattedMessage
                                id="LbFurtherRemainingLeaves"
                                defaultMessage="Further remaining leaves will be lapsed, if any"
                              />
                            </p>
                          </li>
                        </ul>
                      </p>
                    </Collapse>
                  </div>
                  {/* <div className="depedent-select-list" onClick={() => this.handleChange("pendingactiontypeid", 3)} aria-expanded={this.state.pendingactiontypeid == 3 ? true : false}>
                                        <span>
                                            <FormattedMessage id="LbTransferTheRemaining" defaultMessage="Transfer the remaining" />
                                        </span>
                                        {this.state.pendingactiontypeid == 3 ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected "></span>}
                                    </div> */}
                  {/* <div className="et-level4">
                                        <Collapse in={this.state.pendingactiontypeid == 3} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                            <span className="margin-bottom-20 width200p">
                                                <Select class="form-control" autofocus placeholder="Select Type"
                                                    options={this.state.remaningType}
                                                    getOptionLabel={(option) => option.displayname}
                                                    getOptionValue={(option) => option.displayvalue}
                                                    onChange={this.handleChange.bind(this, "remaningtypeid")}
                                                    value={this.state.remaningtypeid}
                                                />
                                            </span>
                                            <InputValues
                                                min="1"
                                                field={this.state.remaningtypeid.displayvalue == 2 ? "noofremaning" : "remaningperc"}
                                                max={this.state.remaningtypeid.displayvalue == 2 ? "365" : "100"}
                                                onChange={this.CommonNumberChange.bind(this,
                                                    this.state.remaningtypeid.displayvalue == 2 ? "noofremaning" : "remaningperc",
                                                    this.state.remaningtypeid.displayvalue == 2 ? "365" : "100"
                                                )}
                                                value={this.state.remaningtypeid.displayvalue == 2
                                                    ? this.state.noofremaning
                                                    : this.state.remaningperc}
                                                defaultvalue={this.state.remaningtypeid.displayvalue == 2
                                                    ? this.state.noofremaning
                                                    : this.state.remaningperc}
                                                disabled={this.state.remaningtypeid.displayvalue == 1}
                                            />

                                            <br />
                                            <FormattedMessage id="LbUnusedLeaveBalance" defaultMessage="unused leave balance to leave type" />
                                            <span className="margin-bottom-20 width200p margin-left-8">
                                                <Select class="form-control" autofocus placeholder="Select Type"
                                                    options={this.state.LeaveList}
                                                    getOptionLabel={(option) => option.displayname}
                                                    getOptionValue={(option) => option.displayvalue}
                                                    onChange={this.handleChange.bind(this, "transferleaveid")}
                                                    value={this.state.transferleaveid}
                                                />
                                            </span>
                                            <p>
                                                <ul className="padding0 margin-bottom-0">
                                                    <li style={{listStyleType:"none"}}>
                                                        <p className="t-14 margin-bottom-0">
                                                            <FormattedMessage id="LbFurtherRemainingLeaves" defaultMessage="Further remaining leaves will be lapsed, if any" />
                                                        </p>
                                                    </li>
                                                </ul>
                                            </p>
                                        </Collapse>
                                    </div> */}
                </Collapse>
              </div>
            </Collapse>
          </div>
          {/* <p class="depedent-select-list-head margin-top-20">
                        <FormattedMessage id="LbInitiateEncashmentBeforeDue" defaultMessage="Do you want to allow employees to initiate encashment request before it is due?" />
                        <div className="depedent-select-list" aria-expanded={this.state.initiateEncashment == true ? true : false}>
                            <span><FormattedMessage id="LbYes" defaultMessage="Yes" /></span>
                            {this.state.initiateEncashment == true ? <span onClick={() => this.handleChange("initiateEncashment", true)} className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected " onClick={() => this.handleChange("initiateEncashment", true)}></span>}
                        </div>
                        <div className="et-level2">
                            <Collapse in={this.state.initiateEncashment} timeout={2} unmountOnExit className="padding30 overflow-initial">
                                <FormattedMessage id="LbMinimumAvailableLeaveBalance" defaultMessage="The minimum available leave balance required to initiate encashment request is" />
                                <br />
                                <InputValues
                                    min="1"
                                    field="initiateEncashmentleavecount"
                                    max="300"
                                    onChange={this.CommonNumberChange.bind(this,
                                        "initiateEncashmentleavecount",
                                        300
                                    )}
                                    value={this.state.initiateEncashmentleavecount}
                                    defaultvalue={this.state.initiateEncashmentleavecount}
                                    disabled={!this.state.initiateEncashment}
                                />
                                {/* <span className='number-wrapper'>
                                    <input
                                        className="seatlimit"
                                        type="number"
                                        min="1"
                                        max="300"
                                        onChange={this.handleChange.bind(this, "initiateEncashmentleavecount")}
                                        value={this.state.initiateEncashmentleavecount}
                                        disabled={!this.state.initiateEncashment}
                                    />
                                </span>
                            </Collapse>
                        </div>
                        <div className="depedent-select-list" onClick={() => this.handleChange("initiateEncashment", false)} aria-expanded={this.state.initiateEncashment == false ? true : false}>
                            <span><FormattedMessage id="LbNo" defaultMessage="No" /></span>
                            {this.state.initiateEncashment == false ? <span className="floatright"><img src={CheckImg} height="20" /></span> : <span className="not-selected "></span>}
                        </div>
                    </p> */}
        </div>
      </IntlProvider>
    );
  }
}
CarryForwardEncashment.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles, { withTheme: true })(withSnackbar(CarryForwardEncashment)),
);
